import {
  FETCH_TOTAL_COUNT_REQUEST,
  FETCH_TOTAL_COUNT_SUCCESS,
  FETCH_TOTAL_COUNT_FAILURE,
  FETCH_TOTAL_REVENUE_REQUEST,
  FETCH_TOTAL_REVENUE_SUCCESS,
  FETCH_TOTAL_REVENUE_FAILURE,
  FETCH_DATA_BY_DATE_REQUEST,
  FETCH_DATA_BY_DATE_SUCCESS,
  FETCH_DATA_BY_DATE_FAILURE,
  FETCH_STATUS_DISTRIBUTION_REQUEST,
  FETCH_STATUS_DISTRIBUTION_SUCCESS,
  FETCH_STATUS_DISTRIBUTION_FAILURE,
  FETCH_TOP_DRIVERS_REQUEST,
  FETCH_TOP_DRIVERS_SUCCESS,
  FETCH_TOP_DRIVERS_FAILURE,
  FETCH_DISTRICT_REPORTS_REQUEST,
  FETCH_DISTRICT_REPORTS_SUCCESS,
  FETCH_DISTRICT_REPORTS_FAILURE,
  FETCH_TOP_USERS_BY_SPENDING_REQUEST,
  FETCH_TOP_USERS_BY_SPENDING_SUCCESS,
  FETCH_TOP_USERS_BY_SPENDING_FAILURE,
  FETCH_TOP_USERS_BY_PACKAGES_REQUEST,
  FETCH_TOP_USERS_BY_PACKAGES_SUCCESS,
  FETCH_TOP_USERS_BY_PACKAGES_FAILURE,
  FETCH_RECENT_TRANSACTIONS_REQUEST,
  FETCH_RECENT_TRANSACTIONS_SUCCESS,
  FETCH_RECENT_TRANSACTIONS_FAILURE,
} from './types';

import {
  fetchTotalCount,
  fetchTotalRevenue,
  fetchDataByDate,
  fetchStatusDistribution,
  fetchTopDrivers,
  fetchDistrictReports,
  fetchTopUsersBySpending,
  fetchTopUsersByPackages,
  fetchRecentTransactions
} from "services/analyticsService";

// Action Creators
export const fetchTotalCountRequest = () => ({ type: FETCH_TOTAL_COUNT_REQUEST });
export const fetchTotalCountSuccess = (countData) => ({
  type: FETCH_TOTAL_COUNT_SUCCESS,
  payload: countData,
});
export const fetchTotalCountFailure = (error) => ({
  type: FETCH_TOTAL_COUNT_FAILURE,
  payload: error,
});

export const fetchTotalRevenueRequest = () => ({ type: FETCH_TOTAL_REVENUE_REQUEST });
export const fetchTotalRevenueSuccess = (revenueData) => ({
  type: FETCH_TOTAL_REVENUE_SUCCESS,
  payload: revenueData,
});
export const fetchTotalRevenueFailure = (error) => ({
  type: FETCH_TOTAL_REVENUE_FAILURE,
  payload: error,
});

export const fetchDataByDateRequest = () => ({ type: FETCH_DATA_BY_DATE_REQUEST });
export const fetchDataByDateSuccess = (dataByDate) => ({
  type: FETCH_DATA_BY_DATE_SUCCESS,
  payload: dataByDate,
});
export const fetchDataByDateFailure = (error) => ({
  type: FETCH_DATA_BY_DATE_FAILURE,
  payload: error,
});

export const fetchStatusDistributionRequest = () => ({ type: FETCH_STATUS_DISTRIBUTION_REQUEST });
export const fetchStatusDistributionSuccess = (statusDistribution) => ({
  type: FETCH_STATUS_DISTRIBUTION_SUCCESS,
  payload: statusDistribution,
});
export const fetchStatusDistributionFailure = (error) => ({
  type: FETCH_STATUS_DISTRIBUTION_FAILURE,
  payload: error,
});

export const fetchTopDriversRequest = () => ({ type: FETCH_TOP_DRIVERS_REQUEST });
export const fetchTopDriversSuccess = (topDrivers) => ({
  type: FETCH_TOP_DRIVERS_SUCCESS,
  payload: topDrivers,
});
export const fetchTopDriversFailure = (error) => ({
  type: FETCH_TOP_DRIVERS_FAILURE,
  payload: error,
});

export const fetchDistrictReportsRequest = () => ({ type: FETCH_DISTRICT_REPORTS_REQUEST });
export const fetchDistrictReportsSuccess = (districtReports) => ({
  type: FETCH_DISTRICT_REPORTS_SUCCESS,
  payload: districtReports,
});
export const fetchDistrictReportsFailure = (error) => ({
  type: FETCH_DISTRICT_REPORTS_FAILURE,
  payload: error,
});

export const fetchTopUsersBySpendingRequest = () => ({ type: FETCH_TOP_USERS_BY_SPENDING_REQUEST });
export const fetchTopUsersBySpendingSuccess = (topUsersBySpending) => ({
  type: FETCH_TOP_USERS_BY_SPENDING_SUCCESS,
  payload: topUsersBySpending,
});
export const fetchTopUsersBySpendingFailure = (error) => ({
  type: FETCH_TOP_USERS_BY_SPENDING_FAILURE,
  payload: error,
});

export const fetchTopUsersByPackagesRequest = () => ({ type: FETCH_TOP_USERS_BY_PACKAGES_REQUEST });
export const fetchTopUsersByPackagesSuccess = (topUsersByPackages) => ({
  type: FETCH_TOP_USERS_BY_PACKAGES_SUCCESS,
  payload: topUsersByPackages,
});
export const fetchTopUsersByPackagesFailure = (error) => ({
  type: FETCH_TOP_USERS_BY_PACKAGES_FAILURE,
  payload: error,
});

export const fetchRecentTransactionsRequest = () => ({ type: FETCH_RECENT_TRANSACTIONS_REQUEST });
export const fetchRecentTransactionsSuccess = (transactions) => ({
  type: FETCH_RECENT_TRANSACTIONS_SUCCESS,
  payload: transactions,
});
export const fetchRecentTransactionsFailure = (error) => ({
  type: FETCH_RECENT_TRANSACTIONS_FAILURE,
  payload: error,
});

// Thunks for each action
export const fetchTotalCountAction = (tableName) => async (dispatch) => {
  dispatch(fetchTotalCountRequest());

  try {
    const response = await fetchTotalCount(tableName); // Ensure this function returns the correct response

    if (response.error) {
      dispatch(fetchTotalCountFailure(response.error));
      return { success: false, error: response.error };
    } else {
      // Dispatch success action with the correct table and count
      const count = response || 0;
      dispatch(fetchTotalCountSuccess({ table: tableName, count }));

      return { success: true, data: { table: tableName, count } };  // Return count along with table name
    }
  } catch (error) {
    dispatch(fetchTotalCountFailure(error.message || "Failed to fetch total count"));
    return { success: false, error: error.message || "Failed to fetch total count" };
  }
};


export const fetchTotalRevenueAction = (tableName) => async (dispatch) => {
  dispatch(fetchTotalRevenueRequest());

  try {
    const response = await fetchTotalRevenue(tableName);

    if (response.error) {
      dispatch(fetchTotalRevenueFailure(response.error));
      return { success: false, error: response.error };
    }

    const today = new Date().toISOString().split("T")[0];

    let total = 0;
    let todayRevenue = 0;

    for (const entry of response) {
      total += entry.total;
      if (entry.date === today) {
        todayRevenue = entry.total;
      }
    }

    const roundedToday = parseFloat(todayRevenue.toFixed(2));
    const roundedTotal = parseFloat(total.toFixed(2));

    dispatch(fetchTotalRevenueSuccess({ today: roundedToday, total: roundedTotal }));

    return { success: true, data: { today: roundedToday, total: roundedTotal } };
  } catch (error) {
    dispatch(fetchTotalRevenueFailure(error.message || "Failed to fetch revenue"));
    return { success: false, error: error.message || "Failed to fetch revenue" };
  }
};


export const fetchDataByDateAction = (tableName, days = 30) => async (dispatch) => {
  dispatch(fetchDataByDateRequest());

  try {
    const response = await fetchDataByDate(tableName, days);

    if (response.error) {
      dispatch(fetchDataByDateFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchDataByDateSuccess({ table: tableName, data: response }));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchDataByDateFailure(error.message || "Failed to fetch data by date"));
    return { success: false, error: error.message || "Failed to fetch data by date" };
  }
};

export const fetchStatusDistributionAction = (tableName) => async (dispatch) => {
  dispatch(fetchStatusDistributionRequest());

  try {
    const response = await fetchStatusDistribution(tableName);

    // Check that you are not redeclaring 'table' anywhere here

    const statusCounts = response.map(entry => ({
      status: entry.status,
      count: entry.count,
    }));

    dispatch(fetchStatusDistributionSuccess({ table: tableName, statusCounts }));
  } catch (error) {
    dispatch(fetchStatusDistributionFailure(error.message || "Failed to fetch status distribution"));
  }
};


export const fetchTopDriversAction = (limit = 5) => async (dispatch) => {
  dispatch(fetchTopDriversRequest());

  try {
    const response = await fetchTopDrivers(limit);

    if (response.error) {
      dispatch(fetchTopDriversFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchTopDriversSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchTopDriversFailure(error.message || "Failed to fetch top drivers"));
    return { success: false, error: error.message || "Failed to fetch top drivers" };
  }
};

export const fetchDistrictReportsAction = (limit = 5) => async (dispatch) => {
  dispatch(fetchDistrictReportsRequest());

  try {
    const response = await fetchDistrictReports(limit);

    if (response.error) {
      dispatch(fetchDistrictReportsFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchDistrictReportsSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchDistrictReportsFailure(error.message || "Failed to fetch district reports"));
    return { success: false, error: error.message || "Failed to fetch district reports" };
  }
};

export const fetchTopUsersBySpendingAction = () => async (dispatch) => {
  dispatch(fetchTopUsersBySpendingRequest());

  try {
    const response = await fetchTopUsersBySpending();

    if (response.error) {
      dispatch(fetchTopUsersBySpendingFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchTopUsersBySpendingSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchTopUsersBySpendingFailure(error.message || "Failed to fetch top users by spending"));
    return { success: false, error: error.message || "Failed to fetch top users by spending" };
  }
};

export const fetchTopUsersByPackagesAction = () => async (dispatch) => {
  dispatch(fetchTopUsersByPackagesRequest());

  try {
    const response = await fetchTopUsersByPackages();

    if (response.error) {
      dispatch(fetchTopUsersByPackagesFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchTopUsersByPackagesSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchTopUsersByPackagesFailure(error.message || "Failed to fetch top users by packages"));
    return { success: false, error: error.message || "Failed to fetch top users by packages" };
  }
};


// Thunk for fetching recent transactions
export const fetchRecentTransactionsAction = (limit = 5) => async (dispatch) => {
  dispatch(fetchRecentTransactionsRequest());

  try {
    const response = await fetchRecentTransactions(limit);

    if (response.error) {
      dispatch(fetchRecentTransactionsFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchRecentTransactionsSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchRecentTransactionsFailure(error.message || "Failed to fetch recent transactions"));
    return { success: false, error: error.message || "Failed to fetch recent transactions" };
  }
};